module.exports = require("shortid");